module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "a6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-head"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Figures#a31"
    }
  }, [_vm._v("Figures")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Tables#a108"
    }
  }, [_vm._v("Tables")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter_1#a137"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Part_1#a146"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part I. Economic Efficiency and the Role of Government")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-list"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter_3#a147"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("1.")]), _vm._v(" Income Equality: The Earliest Standard of Efficiency")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-list"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/14_Chapter_4#a163"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("2.")]), _vm._v(" Equality Does Not Matter: Pareto Efficiency and the Free Market")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter_5#a178",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("3.")]), _vm._v(" The Pareto Efficiency Cops")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter_6#a187",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("4.")]), _vm._v(" Why Redistributing Goods May Be Pareto Efficient After All")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter_7#a188",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("5.")]), _vm._v(" A Brief History of the Federal Income Tax")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter_8#a193",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("6.")]), _vm._v(" It Is Not Pareto Efficient: The Rich Pay Too Much Taxes (Or, Laffer’s Napkin)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter_9#a210",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("7.")]), _vm._v(" Private Goods")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter_10#a229",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("8.")]), _vm._v(" Government-Supplied Goods")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Part_2#a256",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part II. Theories of Wages")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter_12#a257",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("9.")]), _vm._v(" The Classical Theory of Wages")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter_13#a275",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum1"
  }, [_vm._v("10.")]), _vm._v(" The Neo-classical Theory of Wages: John Bates Clark")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter_14#a286",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum1"
  }, [_vm._v("11.")]), _vm._v(" The Evidence")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter_15#a294",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum1"
  }, [_vm._v("12.")]), _vm._v(" The Minimum Wage")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter_16#a306",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum1"
  }, [_vm._v("13.")]), _vm._v(" Theories of Wages and the Great Depression")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-list"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter_17#a313",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum1"
  }, [_vm._v("14.")]), _vm._v(" “Sticky Wages”")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter_18#a320",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum1"
  }, [_vm._v("15.")]), _vm._v(" “Efficiency Wages” or: Why Unemployment Is the Fault of Shirking by Workers")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter_19#a324",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum1"
  }, [_vm._v("16.")]), _vm._v(" Executive Compensation")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-top"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter_20#a332",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter_21#a333",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter_22#a334",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0